import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import { Logo } from './Logo';
import { PAYPAL_URL } from '../utils/donate';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-950 pt-16 pb-8 border-t-4 border-pac-red text-slate-300" data-id="element-86" data-mp="32oe1fz8zkhcr">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87" data-mp="36p6aoshuym91">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-88" data-mp="36nd6djupwe47">
          <div className="col-span-1 md:col-span-2" data-id="element-89" data-mp="3ugbrb9vmhike">
            <div className="mb-6" data-id="element-90" data-mp="38h5b9u0hiky">
              <Logo className="h-14" data-id="element-91" data-mp="37o2ul235f8m" />
            </div>
            <p className="text-slate-400 mb-6 max-w-md leading-relaxed" data-id="element-92" data-mp="3lec9ifcsaage">
              A statewide coalition protecting local decision-making and
              advancing policies that strengthen Arizona&apos;s cities and
              towns. Built locally. Stronger together.
            </p>
            <a href="/#join" className="inline-flex items-center gap-2 border-2 border-pac-gold text-pac-gold hover:bg-pac-gold hover:text-pac-navy px-5 py-2.5 rounded font-bold uppercase tracking-wider text-sm transition-colors" data-id="element-93" data-mp="2a1jhr4jztm0c">
              Join the Coalition
            </a>
          </div>

          <div data-id="element-94" data-mp="3v7zvpch5iql7">
            <h2 className="text-white font-serif font-bold text-lg mb-6 uppercase tracking-wider" data-id="element-95" data-mp="3v8hp81cfiqpf">
              Quick Links
            </h2>
            <ul className="space-y-3" data-id="element-96" data-mp="3qazo2x4nlfrz">
              <li data-id="element-97" data-mp="828qmgkzanef">
                <a href="/#mission" className="hover:text-pac-gold transition-colors" data-id="element-98" data-mp="81foxu0vmo35">
                  Our Mission
                </a>
              </li>
              <li data-id="element-99" data-mp="hsa8gqmqn9kw">
                <a href="/#commitments" className="hover:text-pac-gold transition-colors" data-id="element-100" data-mp="huo533x2gtuk">
                  Our Commitments
                </a>
              </li>
              <li data-id="element-101" data-mp="mrwrxht5tm25">
                <a href="/#issues" className="hover:text-pac-gold transition-colors" data-id="element-102" data-mp="msg56l7v7m9u">
                  Where Local Voices Matter
                </a>
              </li>
              <li data-id="element-103" data-mp="yuzcs1ddblny">
                <a href="/#join" className="hover:text-pac-gold transition-colors" data-id="element-104" data-mp="yuh7ygcn3z4f">
                  Join the Coalition
                </a>
              </li>
              <li data-id="element-105" data-mp="18m3sx4es5ckd">
                <a href="/#leadership" className="hover:text-pac-gold transition-colors" data-id="element-106" data-mp="1clmaprbb17iz">
                  Board of Directors
                </a>
              </li>
              <li data-id="element-107" data-mp="1mj8v2tbdhrac">
                <Link to="/news" className="hover:text-pac-gold transition-colors" data-id="element-108" data-mp="1mktqel5ihe99">
                  News & Updates
                </Link>
              </li>
              <li data-id="element-109" data-mp="3ocggmkhkx54o">
                <a href={PAYPAL_URL} target="_blank" rel="noopener noreferrer" className="text-pac-red font-bold hover:text-red-400 transition-colors" data-id="element-110" data-mp="3oczt3logn1bb">
                  Contribute
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-111" data-mp="21mjyf1xrll4l">
            <h2 className="text-white font-serif font-bold text-lg mb-6 uppercase tracking-wider" data-id="element-112" data-mp="21m0krxf5diwd">
              Contact
            </h2>
            <ul className="space-y-4" data-id="element-113" data-mp="1wpjtwvgkcqfl">
              <li className="flex items-start gap-3" data-id="element-114" data-mp="2tdpt32upuqmh">
                <MapPin className="h-5 w-5 text-pac-gold shrink-0 mt-0.5" data-id="element-115" data-mp="2td6mgiainonr" />
                <span data-id="element-116" data-mp="2pdpg7mn9mnhj">
                  AZ City PAC
                  <br data-id="element-117" data-mp="2kdb49tijmte8" />
                  Arizona
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-118" data-mp="2kf4flm43q1sk">
                <Mail className="h-5 w-5 text-pac-gold shrink-0" data-id="element-119" data-mp="2fdf09u9uj1yo" />
                <span data-id="element-120" data-mp="18ynubc5v8qxs">info@azcitypac.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col items-center text-center" data-id="element-121" data-mp="13ys1m92mclxj">
          <div className="border-2 border-slate-700 p-4 mb-6 max-w-3xl w-full" data-id="element-122" data-mp="2rvhglp6f6d8l">
            <p className="text-sm font-bold text-slate-400 uppercase tracking-wider" data-id="element-123" data-mp="2wm7lz2euig3a">
              Paid for by AZ City PAC. Not
              authorized by any candidate or candidate&apos;s committee.
            </p>
          </div>
          <p className="text-xs text-slate-500 max-w-3xl mb-4" data-id="element-124" data-mp="2nv7b0dmjhou9">
            Contributions to AZ City PAC are not
            deductible as charitable contributions for federal income tax
            purposes. Federal law requires us to use our best efforts to collect
            and report the name, mailing address, occupation, and name of
            employer of individuals whose contributions exceed $200 in a
            calendar year.
          </p>
          <p className="text-xs text-slate-600" data-id="element-125" data-mp="1q6doca5pxylf">
            &copy; {new Date().getFullYear()} AZ City PAC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}